import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";

type Props = {
  node?: any;
};

function Resource({ node }: Props) {
  const { title, label, figma, pdf } = node;
  const [hoveredItem, setHoveredItem] = useState("");

  function onClick(
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    type: string
  ) {
    if (typeof window !== "undefined") {
      (window as any).dataLayer.push({
        event:
          type == "figma"
            ? "click_figma_community_link"
            : "click_pdf_download_link",
      });
    }
  }

  return (
    <div className="my-8 sm:my-16">
      <div className="flex gap-1 items-center mb-4">
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.83467 9.73501C7.43943 10.334 6.56057 10.334 6.16533 9.73501L1.09502 2.05074C0.656331 1.38588 1.13315 0.499999 1.9297 0.499999L12.0703 0.5C12.8669 0.5 13.3437 1.38589 12.905 2.05074L7.83467 9.73501Z"
            fill="#7DC1D2"
          />
        </svg>

        <span className="text-neutral-60 text-xs font-bold">{label}</span>
      </div>

      <div className="flex flex-col gap-4">
        {figma && (
          <a
            href={figma}
            rel="noopener noreferrer"
            target="_blank"
            className="group bg-neutral-99 rounded px-3 sm:px-6 py-3 sm:py-4 flex gap-3 sm:gap-6 items-center justify-between"
            onClick={(e) => onClick(e, "figma")}
            onMouseEnter={() => setHoveredItem("figma")}
            onMouseLeave={() => setHoveredItem("")}>
            <div className="flex items-center gap-4">
              <StaticImage
                src="../../../assets/images/resource-figma.png"
                alt={`${title}をFigma Communityでダウンロード`}
                height={56}
              />
              <div className="font-semibold text-neutral-30">
                {title}（Figma）
              </div>
            </div>

            <div className="shrink-0 hidden sm:flex items-center gap-2 bg-white border border-neutral-90 rounded p-4">
              <span className="text-sm font-semibold leading-[1em] group-hover:text-cyan-strong">
                Figma Community
              </span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.33333 1C9.33333 0.447715 9.78105 0 10.3333 0H15C15.5523 0 16 0.447715 16 1L16 5.66667C16 6.21895 15.5523 6.66667 15 6.66667C14.4477 6.66667 14 6.21895 14 5.66667L14 3.41421L9.48489 7.92933C9.09436 8.31985 8.4612 8.31985 8.07067 7.92933C7.68015 7.53881 7.68015 6.90564 8.07067 6.51512L12.5858 2H10.3333C9.78105 2 9.33333 1.55228 9.33333 1ZM4.69365 1.55555L6.44445 1.55556C6.99673 1.55556 7.44445 2.00327 7.44445 2.55556C7.44445 3.10784 6.99673 3.55556 6.44445 3.55556H4.73334C4.06344 3.55556 3.62116 3.55633 3.28224 3.58402C2.95499 3.61076 2.81311 3.65752 2.72801 3.70088C2.47713 3.82871 2.27316 4.03269 2.14533 4.28357C2.10197 4.36866 2.05521 4.51055 2.02847 4.83779C2.00078 5.17671 2 5.61899 2 6.28889V11.2667C2 11.9366 2.00078 12.3788 2.02847 12.7178C2.05521 13.045 2.10197 13.1869 2.14533 13.272C2.27316 13.5229 2.47713 13.7268 2.72801 13.8547C2.81311 13.898 2.95499 13.9448 3.28224 13.9715C3.62116 13.9992 4.06344 14 4.73334 14H9.71111C10.381 14 10.8233 13.9992 11.1622 13.9715C11.4895 13.9448 11.6313 13.898 11.7164 13.8547C11.9673 13.7268 12.1713 13.5229 12.2991 13.272C12.3425 13.1869 12.3892 13.045 12.416 12.7178C12.4437 12.3788 12.4444 11.9366 12.4444 11.2667V9.55556C12.4444 9.00327 12.8922 8.55556 13.4444 8.55556C13.9967 8.55556 14.4444 9.00327 14.4444 9.55556V11.3063C14.4445 11.9259 14.4445 12.4505 14.4093 12.8806C14.3725 13.3316 14.2921 13.7659 14.0811 14.18C13.7616 14.8072 13.2516 15.3171 12.6244 15.6367C12.2104 15.8476 11.776 15.928 11.3251 15.9649C10.895 16 10.3704 16 9.75082 16H4.69363C4.07406 16 3.54947 16 3.11937 15.9649C2.66844 15.928 2.23406 15.8476 1.82003 15.6367C1.19283 15.3171 0.682891 14.8072 0.363313 14.18C0.152353 13.7659 0.0719546 13.3316 0.0351122 12.8806C-2.85432e-05 12.4505 -1.50728e-05 11.9259 6.62825e-07 11.3064V6.2492C-1.50728e-05 5.62962 -2.85432e-05 5.10503 0.0351122 4.67493C0.0719546 4.224 0.152353 3.78962 0.363313 3.37559C0.682891 2.74838 1.19283 2.23845 1.82003 1.91887C2.23406 1.70791 2.66845 1.62751 3.11937 1.59067C3.54948 1.55553 4.07407 1.55554 4.69365 1.55555Z"
                  fill={hoveredItem == "figma" ? "#3E9BB2" : "#1B1B1E"}
                />
              </svg>
            </div>
          </a>
        )}

        {pdf && (
          <a
            href={pdf}
            target="_blank"
            className="group bg-neutral-99 rounded px-3 sm:px-6 py-3 sm:py-4 flex gap-3 sm:gap-6 items-center justify-between"
            onClick={(e) => onClick(e, "pdf")}
            onMouseEnter={() => setHoveredItem("pdf")}
            onMouseLeave={() => setHoveredItem("")}>
            <div className="flex items-center gap-4">
              <StaticImage
                src="../../../assets/images/resource-pdf.png"
                alt={`${title}をPDFとしてダウンロード`}
                height={56}
              />
              <div className="font-semibold text-neutral-30">
                {title}（PDF）
              </div>
            </div>

            <div className="shrink-0 hidden sm:flex items-center gap-2 bg-white border border-neutral-90 rounded p-4">
              <span className="text-sm font-semibold leading-[1em] group-hover:text-cyan-strong">
                PDFをダウンロード
              </span>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17 11.6667V12.7333C17 14.2268 17 14.9735 16.7094 15.544C16.4537 16.0457 16.0457 16.4537 15.544 16.7094C14.9735 17 14.2268 17 12.7333 17H5.26667C3.77319 17 3.02646 17 2.45603 16.7094C1.95426 16.4537 1.54631 16.0457 1.29065 15.544C1 14.9735 1 14.2268 1 12.7333V11.6667M13.4444 7.22222L9 11.6667M9 11.6667L4.55556 7.22222M9 11.6667V1"
                  stroke={hoveredItem == "pdf" ? "#3E9BB2" : "#1B1B1E"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </a>
        )}
      </div>
    </div>
  );
}

export default Resource;
